import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import { environment } from "src/environments/environment";
import { OverviewPropertyCard } from "../../models/contact-overview.model";

/**
 * Linha compacta de imóvel (capa, referência, título, preço) reutilizada nas
 * tabs Leads / Negócios / Imóveis da visão 360º. Sem imóvel interno mostra a
 * referência externa quando existe.
 */
@Component({
  selector: "app-contact-overview-property-card",
  templateUrl: "./contact-overview-property-card.component.html",
  styleUrls: ["./contact-overview-property-card.component.scss"],
})
export class ContactOverviewPropertyCardComponent implements OnChanges {
  @Input() property: OverviewPropertyCard | null = null;
  @Input() externalReference: string | null = null;
  @Input() clickable = true;
  @Output() open = new EventEmitter<OverviewPropertyCard>();

  private readonly pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
  readonly placeholder = "assets/images/placeholder.png";

  imageUrl = this.placeholder;

  ngOnChanges(): void {
    this.imageUrl = this.property?.coverFileName
      ? `${this.pathImage}${this.property.coverFileName}`
      : this.placeholder;
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = this.placeholder;
  }

  /**
   * Só consome o clique quando o card é mesmo clicável; senão deixa-o subir
   * para a linha (que abre a lead, o negócio ou a visita).
   */
  onOpen(event: Event): void {
    if (!this.property || !this.clickable) return;
    event.stopPropagation();
    this.open.emit(this.property);
  }
}
